module.exports = __webpack_public_path__ + "static/media/CTLI_17-178w.bd7c33ac.png";